import { render, staticRenderFns } from "./ptjs.vue?vue&type=template&id=02c2b622&scoped=true&"
import script from "./ptjs.vue?vue&type=script&lang=js&"
export * from "./ptjs.vue?vue&type=script&lang=js&"
import style0 from "./ptjs.vue?vue&type=style&index=0&id=02c2b622&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2b622",
  null
  
)

export default component.exports